import script from "./MessageBox.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageBox.vue?vue&type=script&setup=true&lang=js"

import "./MessageBox.vue?vue&type=style&index=0&id=b90c3432&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b90c3432"]])

export default __exports__